/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "@/scss/main.scss?vue&type=style&index=0&lang=scss"

const __exports__ = script;

export default __exports__